// extracted by mini-css-extract-plugin
export default {"container":"VideoGrid_container__O+17H"};